import { useEffect, useRef, useState } from 'react';

export const useCountdown = (endDate: Date) => {
  const interval = useRef<ReturnType<typeof setInterval>>(null);
  const [seconds, setSeconds] = useState<number>(null);

  useEffect(() => {
    if (!endDate) return;
    interval.current = setInterval(() => {
      setSeconds(Math.floor((endDate.getTime() - Date.now()) / 1000));
    }, 1000);

    return () => {
      clearInterval(interval.current);
      setSeconds(null);
    };
  }, [endDate]);

  if (!seconds || seconds < 0) return '';

  const minutes = Math.floor(seconds / 60);

  return `${minutes.toString()}:${seconds.toString().padStart(2, '0')}`;
};
